<template>
  <lb-datatablenew
    data-testid="task-due-notification-table"
    :headers="headers"
    :items="formattedNotifications"
    :enableslot="['scheduler', 'action', 'status', 'locationString', 'roleString']"
    :loading="loading"
    v-if="formattedNotifications.length > 0"
  >
    <template v-slot:scheduler="{ item }">
      <span data-testid="task-due-notification-table__scheduler">{{ item.schedulerTiming || "24" }}</span>
    </template>
    <template v-slot:status="{ item }">
      <v-chip label class="success" v-if="item.status === 'Enabled'" data-testid="task-due-notification-table__status-chip--enabled"><span>Enabled</span></v-chip>
      <v-chip label v-else data-testid="task-due-notification-table__status-chip--disabled"><span>Disabled</span></v-chip>
    </template>
    <template v-slot:locationString="{ item }">
      <div data-testid="task-due-notification-table__locations-chip-container">
        <v-chip
          v-for="loc in item._locations"
          :key="loc.value"
          class="ma-1"
          color="red lighten-4"
          data-testid="task-due-notification-table__locations-chip__item"
        >
          <span>{{ loc.name }}</span>
        </v-chip>
      </div>
    </template>
    <template v-slot:roleString="{ item }">
      <div data-testid="task-due-notification-table__roles-chip-container">
        <v-chip
          v-for="role in item._roles"
          :key="role.value"
          class="ma-1"
          color="lightblue"
          data-testid="task-due-notification-table__roles-chip__item"
        >
          <span>{{ role.name }}</span>
        </v-chip>
      </div>
    </template>
    <template v-slot:action="{ item }">
      <div class="d-flex align-center" data-testid="task-due-notification-table__actions-row">
        <v-tooltip bottom content-class="tooltip-bottom" v-if="item.status === 'Enabled'" data-testid="task-due-notification-table__disable-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-1"
              @click.stop="$emit('toggle', item, false)"
              v-bind="attrs"
              v-on="on"
              icon
              data-testid="task-due-notification-table__disable-btn"
            >
              <v-icon data-testid="task-due-notification-table__disable-icon">mdi-check</v-icon>
            </v-btn>
          </template>
          <span data-testid="task-due-notification-table__disable-tooltip-text">Disable Notification</span>
        </v-tooltip>
        <v-tooltip bottom content-class="tooltip-bottom" v-else data-testid="task-due-notification-table__enable-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-1"
              @click.stop="$emit('toggle', item, true)"
              v-bind="attrs"
              v-on="on"
              icon
             
              data-testid="task-due-notification-table__enable-btn"
            >
              <v-icon data-testid="task-due-notification-table__enable-icon">mdi-close</v-icon>
            </v-btn>
          </template>
          <span data-testid="task-due-notification-table__enable-tooltip-text">Enable Notification</span>
        </v-tooltip>
        <v-tooltip bottom content-class="tooltip-bottom" data-testid="task-due-notification-table__edit-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="$emit('edit', { ...item, status: item._originalStatus, roles: item._originalRoles, locations: item._originalLocations })"
              data-testid="task-due-notification-table__edit-btn"
            >
              <v-icon data-testid="task-due-notification-table__edit-icon">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span data-testid="task-due-notification-table__edit-tooltip-text">Update</span>
        </v-tooltip>
         <activity-log
          :resource-id="item.id"
          :row-description="item.labelName"
          data-testid="task-due-notification-table__activity-log-btn"
        />
      </div>
    </template>
  </lb-datatablenew>
  <div v-else class="text-center grey--text title pa-6" data-testid="task-due-notification-table__empty-state">
    No data available
  </div>
</template>

<script>
import ActivityLog from '../../components/ActivityLog/ActivityLog.vue';
export default {
  name: "TaskDueNotificationTable",
  components: {
   ActivityLog
  },
  props: {
    notifications: Array,
    headers: Array,
    loading: Boolean
  },
  data() {
    return {
      page: 1,
      itemsPerPage: 10
    };
  },
    computed: {
    formattedNotifications() {
      return this.notifications.map(item => {
        const formatted = {
          ...item,
          status: item.status ? 'Enabled' : 'Disabled',
          roleString: Array.isArray(item.roles)
            ? item.roles.map(role => role.name).join(', ')
            : '',
          locationString: Array.isArray(item.locations)
            ? item.locations.map(loc => loc.name).join(', ')
            : '',
          schedulerTiming: String(item.schedulerTiming || '24')
        };
        
        // Keep original values for edit action
        formatted._originalStatus = item.status;
        formatted._originalRoles = item.roles;
        formatted._originalLocations = item.locations;
        
        // Keep arrays for slot rendering but exclude from filtering
        formatted._roles = item.roles;
        formatted._locations = item.locations;
        delete formatted.roles;
        delete formatted.locations;
        
        return formatted;
      });
    }
  },
  methods: {
  }
};
</script>